import { DeepCopier } from "../../Misc/deepCopier.js";
import { Vector3, TmpVectors } from "../../Maths/math.vector.js";
/**
 * Particle emitter emitting particles from a custom list of positions.
 */
var CustomParticleEmitter = /** @class */ (function () {
    /**
     * Creates a new instance CustomParticleEmitter
     */
    function CustomParticleEmitter() {
        /**
         * Gets or sets the position generator that will create the initial position of each particle.
         * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */
        this.particlePositionGenerator = function () { };
        /**
         * Gets or sets the destination generator that will create the final destination of each particle.
         *  * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */
        this.particleDestinationGenerator = function () { };
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */
    CustomParticleEmitter.prototype.startDirectionFunction = function (worldMatrix, directionToUpdate, particle, isLocal) {
        var tmpVector = TmpVectors.Vector3[0];
        if (this.particleDestinationGenerator) {
            this.particleDestinationGenerator(-1, particle, tmpVector);
            // Get direction
            var diffVector = TmpVectors.Vector3[1];
            tmpVector.subtractToRef(particle.position, diffVector);
            diffVector.scaleToRef(1 / particle.lifeTime, tmpVector);
        }
        else {
            tmpVector.set(0, 0, 0);
        }
        if (isLocal) {
            directionToUpdate.copyFrom(tmpVector);
            return;
        }
        Vector3.TransformNormalToRef(tmpVector, worldMatrix, directionToUpdate);
    };
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */
    CustomParticleEmitter.prototype.startPositionFunction = function (worldMatrix, positionToUpdate, particle, isLocal) {
        var tmpVector = TmpVectors.Vector3[0];
        if (this.particlePositionGenerator) {
            this.particlePositionGenerator(-1, particle, tmpVector);
        }
        else {
            tmpVector.set(0, 0, 0);
        }
        if (isLocal) {
            positionToUpdate.copyFrom(tmpVector);
            return;
        }
        Vector3.TransformCoordinatesToRef(tmpVector, worldMatrix, positionToUpdate);
    };
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */
    CustomParticleEmitter.prototype.clone = function () {
        var newOne = new CustomParticleEmitter();
        DeepCopier.DeepCopy(this, newOne);
        return newOne;
    };
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CustomParticleEmitter.prototype.applyToShader = function (uboOrEffect) { };
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CustomParticleEmitter.prototype.buildUniformLayout = function (ubo) { };
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */
    CustomParticleEmitter.prototype.getEffectDefines = function () {
        return "#define CUSTOMEMITTER";
    };
    /**
     * Returns the string "PointParticleEmitter"
     * @returns a string containing the class name
     */
    CustomParticleEmitter.prototype.getClassName = function () {
        return "CustomParticleEmitter";
    };
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */
    CustomParticleEmitter.prototype.serialize = function () {
        var serializationObject = {};
        serializationObject.type = this.getClassName();
        return serializationObject;
    };
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CustomParticleEmitter.prototype.parse = function (serializationObject) { };
    return CustomParticleEmitter;
}());
export { CustomParticleEmitter };
//# sourceMappingURL=customParticleEmitter.js.map